import { Link } from "react-router-dom";
import { HeartHandshake, Sparkles, GraduationCap, Scale, Trees, ArrowRight } from "lucide-react";
import { AREAS } from "@/lib/constants";

const CONTENT = {
  famiglie: {
    icon: HeartHandshake,
    intro: "Sostenere chi cresce persone: genitori, nonni, adulti di riferimento. Il benessere di chi si prende cura è al centro.",
    bullets: ["Genitorialità e famiglie al plurale", "Cura e condivisione dei carichi", "Benessere dei genitori", "Paternità attiva"],
  },
  bambini: {
    icon: Sparkles,
    intro: "Spazi di crescita in cui bambine e bambini possono stare, esplorare, sbagliare e imparare.",
    bullets: ["Infanzia, crescita ed educazione", "Gioco e apprendimento", "Diritti e ascolto dei più piccoli"],
  },
  scuola: {
    icon: GraduationCap,
    intro: "Le scuole non stanno sole: intorno c'è una comunità educante che le sostiene.",
    bullets: ["Dialogo scuola-famiglie-territorio", "Progetti in orario scolastico ed extra", "Formazione per insegnanti ed educatori"],
  },
  relazioni: {
    icon: Scale,
    intro: "Relazioni sane, parità, contrasto agli stereotipi. Prevenzione della violenza di genere.",
    bullets: ["Comunicazione Nonviolenta", "Parità ed educazione affettiva", "Contrasto agli stereotipi di genere", "Prevenzione della violenza maschile sulle donne"],
  },
  comunita: {
    icon: Trees,
    intro: "Il territorio è la nostra casa. Reti, cittadinanza attiva, spazi condivisi.",
    bullets: ["Partecipazione e cittadinanza attiva", "Inclusione", "Costruzione di reti territoriali"],
  },
};

export default function CosaFacciamo() {
  return (
    <div data-testid="cosa-facciamo-page">
      <section className="bg-[#FFF1E8] py-20 lg:py-24">
        <div className="container-vv">
          <div className="eyebrow">Cosa facciamo</div>
          <h1 className="mt-4 font-display font-medium text-5xl sm:text-6xl leading-[1.05] tracking-tight text-[#292522] max-w-4xl">
            Cinque aree, un modo <span className="text-[#FF6100]">solo</span> di stare accanto.
          </h1>
          <p className="mt-6 text-lg text-[#292522]/75 max-w-3xl">
            Attraversiamo temi diversi ma con uno stile riconoscibile: ascolto, cura, partecipazione. Ecco le aree principali del nostro lavoro.
          </p>
        </div>
      </section>

      {AREAS.map((area, idx) => {
        const c = CONTENT[area.key];
        const Icon = c.icon;
        const isAlt = idx % 2 === 1;
        return (
          <section key={area.key} id={area.key} className={`py-20 lg:py-24 ${isAlt ? "bg-[#F8F1E8]" : "bg-[#FFFCF8]"}`}>
            <div className="container-vv grid lg:grid-cols-12 gap-10 items-start">
              <div className="lg:col-span-5">
                <div className="h-14 w-14 rounded-2xl bg-[#FF6100]/12 flex items-center justify-center text-[#FF6100] mb-6">
                  <Icon className="h-7 w-7" strokeWidth={1.5} />
                </div>
                <div className="eyebrow">Area {String(idx + 1).padStart(2, "0")}</div>
                <h2 className="mt-3 font-display font-medium text-4xl sm:text-5xl text-[#292522] leading-tight">{area.label}</h2>
              </div>
              <div className="lg:col-span-7 space-y-6">
                <p className="text-lg text-[#292522]/80 leading-relaxed">{c.intro}</p>
                <ul className="grid sm:grid-cols-2 gap-3">
                  {c.bullets.map((b) => (
                    <li key={b} className="rounded-2xl bg-white border border-[#292522]/8 px-5 py-4 text-sm text-[#292522]/85">
                      {b}
                    </li>
                  ))}
                </ul>
                <div className="pt-2 flex flex-wrap gap-3">
                  <Link to={`/progetti?area=${area.key}`} className="btn-ghost">Progetti collegati</Link>
                  <Link to={`/eventi?area=${area.key}`} className="text-sm font-semibold text-[#FF6100] inline-flex items-center gap-1.5 self-center">
                    Eventi in quest'area <ArrowRight className="h-4 w-4" strokeWidth={1.75} />
                  </Link>
                </div>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
}
